/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Sort_DescendingInputs */

const en_disp_sort_descending = /** @type {(inputs: Disp_Sort_DescendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descending, switch to ascending`)
};

const de_disp_sort_descending = /** @type {(inputs: Disp_Sort_DescendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absteigend, auf aufsteigend umschalten`)
};

/**
* | output |
* | --- |
* | "Descending, switch to ascending" |
*
* @param {Disp_Sort_DescendingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_sort_descending = /** @type {((inputs?: Disp_Sort_DescendingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Sort_DescendingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_sort_descending(inputs)
	return en_disp_sort_descending(inputs)
});